var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('img',{staticClass:"video-thumbnail",class:{
        'video-thumbnail--outline-on-hover': _vm.outlineOnHover,
        'video-thumbnail--outlined': _vm.outlined,
      },attrs:{"src":_vm.thumbnailUrl}}),_vm._v(" "),(_vm.tvspot.tvformat.is_socialmedia_format)?_c('span',_vm._l((_vm.tvspot.tvformat
          .socialmedia_icon_urls),function(platformIconUrl,platformIconIndex){return _c('img',{key:platformIconUrl,staticStyle:{"position":"absolute","left":"-12px"},style:({top: -6 + platformIconIndex * 20 + 'px'}),attrs:{"src":platformIconUrl,"width":"20","height":"20"}})})):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/VideoThumbnail.vue?vue&type=template&id=4d3b340d&scoped=true
// module id = 2277
// module chunks = 5